<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.65"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <path :d="path" />
    </svg>
</template>
<script>
const paths = {
    activity: 'M3 12h4l3-8 4 16 3-8h4',
    focus: 'M8 3H3v5 M16 3h5v5 M3 16v5h5 M21 16v5h-5 M9 9h6v6H9z',
    search: 'M21 21l-5-5 M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
    layout: 'M3 3h18v18H3z M12 3v18 M12 12h9',
    layers: 'M12 3l10 5-10 5L2 8z M2 12l10 5 10-5 M2 16l10 5 10-5',
    replay: 'M4 5v14 M20 5l-12 7 12 7z',
    alert: 'M9 20h6 M5 17h14l-2-3V9a5 5 0 0 0-10 0v5z',
    objects: 'M4 5h4v4H4z M12 7h8 M4 15h4v4H4z M12 17h8',
    save: 'M4 3h13l3 3v15H4z M8 3v6h8V3 M8 21v-7h8v7',
    compare: 'M3 16l5-8 5 5 8-10 M3 21l7-6 4 4 7-8',
    camera: 'M3 7h5l2-3h4l2 3h5v14H3z M16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
    settings: 'M4 7h16 M4 17h16 M8 4v6 M16 14v6',
    fullscreen: 'M8 3H3v5 M16 3h5v5 M3 16v5h5 M21 16v5h-5',
    download: 'M12 3v12 M7 10l5 5 5-5 M4 17v4h16v-4',
    undo: 'M8 4L3 9l5 5 M3 9h11a6 6 0 0 1 0 12',
    redo: 'M16 4l5 5-5 5 M21 9H10a6 6 0 0 0 0 12',
    paper: 'M5 3h10l4 4v14H5z M14 3v5h5 M8 12h8 M8 16h5',
    bot: 'M5 8h14v12H5z M12 3v5 M10 3h4 M2 12h3 M19 12h3 M9 12v2 M15 12v2 M9 17h6',
    trade: 'M3 3v18h18 M7 14l4-5 4 3 6-8',
    close: 'M6 6l12 12 M6 18L18 6',
    eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12 M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
    lock: 'M5 10h14v11H5z M8 10V6a4 4 0 0 1 8 0v4',
    delete: 'M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7',
    play: 'M7 4l14 8-14 8z',
    pause: 'M8 4v16 M16 4v16',
    step: 'M4 4l12 8-12 8z M20 4v16',
};
export default {
    props: { name: String },
    computed: {
        path() {
            return paths[this.name] || paths.layout;
        },
    },
};
</script>
